import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/Navigation.css";

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Prevent body scroll when menu is open
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMenuOpen]);

  const scrollToSection = (sectionId) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
    setIsMenuOpen(false);
  };

  const openConsentForm = () => {
    window.open("https://form.jotform.com/251336899549374", "_blank");
    setIsMenuOpen(false);
  };

  const goToPolicies = () => {
    navigate('/policies');
    window.scrollTo(0, 0);
    setIsMenuOpen(false);
  };

  const goHome = () => {
    navigate('/');
    window.scrollTo(0, 0);
  };

  return (
    <>
      {/* Mobile menu backdrop */}
      {isMenuOpen && (
        <div 
          className="mobile-menu-backdrop" 
          onClick={() => setIsMenuOpen(false)}
        />
      )}

      <header className="navigation-header">
        <div className="container">
          <div className="navigation-content">
            <button onClick={goHome} className="navigation-logo">
              <img 
                src="https://customer-assets.emergentagent.com/job_aura-aesthetics-2/artifacts/5wpjtg46_Aura_Clean-removebg-preview.png" 
                alt="Aura Aesthetics Academy Logo" 
                className="logo-image"
              />
            </button>

            <nav className={`navigation-menu ${isMenuOpen ? "mobile-open" : ""}`}>
              <button onClick={() => scrollToSection("about")} className="navigation-link">
                About
              </button>
              <button onClick={() => scrollToSection("services")} className="navigation-link">
                Services
              </button>
              <button onClick={() => scrollToSection("testimonials")} className="navigation-link">
                Testimonials
              </button>
              <button onClick={() => scrollToSection("faq")} className="navigation-link">
                FAQ
              </button>
              <button onClick={goToPolicies} className="navigation-link">
                Policies
              </button>
              <button onClick={openConsentForm} className="navigation-link">
                Consent Form
              </button>
              <button onClick={() => scrollToSection("contact")} className="navigation-link">
                Contact
              </button>
            </nav>

            <div className="navigation-utilities">
              <button
                className="mobile-menu-toggle"
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                aria-label="Toggle menu"
              >
                {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
              </button>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Navigation;
